import { Link } from 'react-router-dom';
import { profile } from '@/mocks/profile';

export default function ProfileTeaser() {
  return (
    <section className="bg-background-50">
      <div className="max-w-6xl mx-auto px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[0.85fr_1.15fr]">
          <div className="relative">
            <div className="aspect-[4/5] w-full overflow-hidden rounded-lg border border-background-200 bg-background-200">
              <img
                src={profile.avatar}
                alt={`${profile.name} 个人照片`}
                title={`${profile.name} 明星资料`}
                className="h-full w-full object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 hidden rounded-lg bg-primary-500 px-5 py-4 text-background-50 md:block">
              <p className="font-heading text-2xl font-black">8+</p>
              <p className="text-xs tracking-wide">年从业经验</p>
            </div>
          </div>

          <div>
            <span className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              <span className="h-3 w-1 rounded-full bg-primary-500"></span>
              About the Star
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {profile.name}
              <span className="ml-3 align-middle text-sm font-normal uppercase tracking-widest text-secondary-500">
                {profile.nameEn}
              </span>
            </h2>
            <p className="mt-2 text-sm font-medium text-primary-600">{profile.tagline}</p>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600">{profile.intro[0]}</p>

            <dl className="mt-7 grid grid-cols-2 gap-y-4 border-t border-background-200 pt-6 sm:grid-cols-3">
              {profile.basicInfo.slice(0, 3).map((info) => (
                <div key={info.label}>
                  <dt className="text-xs uppercase tracking-wide text-secondary-500">{info.label}</dt>
                  <dd className="mt-1 text-sm font-medium text-foreground-900">{info.value}</dd>
                </div>
              ))}
            </dl>

            <Link
              to="/profile"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800 cursor-pointer"
            >
              查看完整资料
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}